import React, { useEffect } from 'react';
import Modal from 'react-modal';
import AppUsageBoard from '../AppUsageBoard';
import '../../styles/newDesign.css';

Modal.setAppElement('#root');

const OVERLAY_STYLE_ID = 'app-usage-modal-overlay-styles';

const overlayCss = `
  .ReactModal__Overlay--app-usage-modal {
    left: 320px !important;
    width: calc(100vw - 320px) !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    position: fixed !important;
    pointer-events: auto !important;
    z-index: 200010 !important;
    background-color: rgba(4, 10, 13, 0.72) !important;
    backdrop-filter: blur(10px);
    display: flex !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .ReactModal__Overlay--app-usage-modal .ReactModal__Content {
    left: 320px !important;
    width: calc(100vw - 320px) !important;
    max-width: calc(100vw - 320px) !important;
    min-width: 0 !important;
    height: 100vh !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: none !important;
    pointer-events: auto !important;
    z-index: 200020 !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    background: transparent !important;
    border: none !important;
    inset: unset !important;
    display: flex !important;
  }
`;

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(4, 10, 13, 0.72)',
    zIndex: 200010,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: '320px',
    width: 'calc(100vw - 320px)',
    height: '100vh',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    pointerEvents: 'auto',
  },
  content: {
    position: 'fixed',
    top: 0,
    left: '320px',
    right: 0,
    bottom: 0,
    width: 'calc(100vw - 320px)',
    maxWidth: 'calc(100vw - 320px)',
    height: '100vh',
    maxHeight: '100vh',
    margin: 0,
    padding: 0,
    inset: 'unset',
    border: 'none',
    background: 'transparent',
    overflow: 'hidden',
    zIndex: 200010,
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    transform: 'none',
    pointerEvents: 'auto',
    boxSizing: 'border-box',
  },
};

export default function AppUsageModal({ isOpen, onRequestClose }) {
  useEffect(() => {
    if (!isOpen) return undefined;
    let style = document.getElementById(OVERLAY_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = OVERLAY_STYLE_ID;
      style.textContent = overlayCss;
      document.head.appendChild(style);
    }
    return () => {
      const node = document.getElementById(OVERLAY_STYLE_ID);
      if (node) node.remove();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      style={modalStyles}
      overlayClassName="ReactModal__Overlay--app-usage-modal"
      contentLabel="Отчет запусков приложения"
    >
      <AppUsageBoard onClose={onRequestClose} />
    </Modal>
  );
}
